/**
 * Layout component that queries for data
 * with Gatsby's StaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/static-query/
 */

import React, { useState } from "react"
import PropTypes from "prop-types"
import styled, { ThemeProvider } from "styled-components"
import { library } from "@fortawesome/fontawesome-svg-core"
import {
  fab,
  faGooglePlusG,
  faFacebook,
  faFacebookF,
} from "@fortawesome/free-brands-svg-icons"
import {
  faCheckSquare,
  faCoffee,
  faSignInAlt,
  faChevronDown,
  faShoppingCart,
  faTimes,
  faEnvelope,
  faLock,
  faBirthdayCake,
} from "@fortawesome/free-solid-svg-icons"

import Header from "./header"
import Footer from "./layout/footer"
import "./layout.css"

library.add(
  faCoffee,
  faSignInAlt,
  faChevronDown,
  faShoppingCart,
  faTimes,
  faGooglePlusG,
  faFacebookF,
  faEnvelope,
  faLock,
  faBirthdayCake
)

const theme = {
  primaryColor: "#EB2E40",
  primaryTextColor: "#3b3b3b",
  secondaryTextColor: "#6b706a",
  tertiaryTextColor: "#CBC8B9",
  primaryAccentBg: "#FFF5F6",
  primaryFont: "'Lato', sans-serif",
  secondaryFont: "Archivo Narrow, sans-serif",
  smallContainerWidth: "1170px",
  bigContainerWidth: "1408px",
  extraSmallBreakpoint: "480px",
  smallBreakpoint: "780px",
  mediumBreakpoint: "1080px",
  largeBreakpoint: "1250px",
  extraLargeBreakpoint: "1450px",
}

const SiteContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 100vh;
`

const defaultState = {
  dark: false,
  toggleDark: () => {},
}

const ThemeContext = React.createContext(defaultState)

const Layout = ({ children }) => (
  <ThemeProvider theme={theme}>
    {/* <StaticQuery
      query={graphql`
        query SiteTitleQuery {
          site {
            siteMetadata {
              title
            }
          }
        }
      `}
      render={data => ( */}
    <>
      <Header siteTitle={"title"} />
      <link
        href="https://fonts.googleapis.com/css?family=Archivo+Narrow:400,500,600,700"
        rel="stylesheet"
      />
      <link
        href="https://fonts.googleapis.com/css?family=Lato:400,500,700,900"
        rel="stylesheet"
      />
      <SiteContainer style={{ overflowX: "hidden" }}>
        <main>{children}</main>
        <Footer />
      </SiteContainer>
    </>
    {/* )}
    /> */}
  </ThemeProvider>
)

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
